import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EValidationMode = {
	all: 'all',
	onBlur: 'onBlur',
	onChange: 'onChange',
	onSubmit: 'onSubmit',
	onTouched: 'onTouched',
} as const;

export const ERevalidationMode = {
	onBlur: 'onBlur',
	onChange: 'onChange',
	onSubmit: 'onSubmit',
} as const;

export type TValidationMode = TValueOfStringRecord<typeof EValidationMode>
export type TRevalidationMode = TValueOfStringRecord<typeof ERevalidationMode>
